import { atom } from 'jotai';
import { $ArticleCategoryPost, IArticleCategoryPost } from 'shared/atoms';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export const $ArticleCategoryPostLoadmore = safeAtomFamily((groupId: string) => {
  const a = atom(null, async (get, set, input: IArticleCategoryPost) => {
    const { items } = await get($ArticleCategoryPost(groupId));

    set($ArticleCategoryPost(groupId), {
      ...input,
      items: [...items, ...input.items],
    });
  });

  a.debugLabel = `$ArticleCategoryPostLoadmore+${encodeURIComponent(groupId)}`;

  return a;
});
